module.exports = __webpack_public_path__ + "static/media/procore@2x.09a393d3.png";